import { css, keyframes } from '@emotion/css';

import { color } from '#components/mobile/ui/tokens';

const mecer = keyframes({
  '0%, 100%': { transform: 'rotate(-2.5deg)' },
  '50%': { transform: 'rotate(2.5deg) translateY(1.5px)' },
});
const olas = keyframes({
  from: { transform: 'translateX(0)' },
  to: { transform: 'translateX(-60px)' },
});

const meciendo = css({
  transformBox: 'fill-box',
  transformOrigin: 'center bottom',
  animation: `${mecer} 3.4s ease-in-out infinite`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});
const agua = css({
  animation: `${olas} 4s linear infinite`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});

type DosVelerosProps = {
  /** El velero de la pareja llega y amarra junto al tuyo. */
  amarrado: boolean;
  width?: number;
};

/**
 * Dos veleros en el muelle: el tuyo amarrado y el de quien invitas, que se
 * acerca y amarra al subir a bordo (dibujo propio).
 */
export function DosVeleros({ amarrado, width = 280 }: DosVelerosProps) {
  const casco = { fill: color.fg };
  const vela = { fill: color.surface, stroke: color.fg, strokeWidth: 1.3 };
  return (
    <svg
      viewBox="0 0 290 190"
      width={width}
      height={(width * 190) / 290}
      aria-hidden
      style={{ overflow: 'visible' }}
    >
      <g className={agua}>
        <path
          d="M-60 150 q30 -7 60 0 t60 0 t60 0 t60 0 t60 0 t60 0 V190 H-60Z"
          style={{ fill: color.accentSoft }}
        />
      </g>
      <rect x="0" y="128" width="96" height="14" rx="3" fill="#c9a46a" />
      <rect x="14" y="142" width="8" height="30" fill="#c9a46a" />
      <rect x="70" y="142" width="8" height="30" fill="#c9a46a" />
      <g className={meciendo}>
        <path d="M18 104 H82 L72 124 H28Z" style={casco} />
        <line
          x1="50"
          y1="104"
          x2="50"
          y2="44"
          stroke={color.fg}
          strokeWidth={1.8}
        />
        <path d="M51 48 L51 100 L78 100Z" style={vela} />
        <path d="M49 54 L49 100 L24 100Z" style={vela} />
      </g>
      <g
        style={{
          transform: amarrado ? 'translateX(0)' : 'translateX(118px)',
          transition: 'transform 1.6s cubic-bezier(.4, 0, .2, 1)',
        }}
      >
        <g className={meciendo}>
          <path d="M92 112 H140 L132 128 H100Z" style={casco} />
          <line
            x1="116"
            y1="112"
            x2="116"
            y2="66"
            stroke={color.fg}
            strokeWidth={1.8}
          />
          <path d="M117 70 L117 108 L136 108Z" style={vela} />
          <path d="M115 74 L115 108 L98 108Z" style={vela} />
        </g>
      </g>
      <path
        d="M82 112 Q 88 122 94 116"
        fill="none"
        stroke="#c9a46a"
        strokeWidth={2}
        strokeDasharray={60}
        style={{
          strokeDashoffset: amarrado ? 0 : 60,
          transition: 'stroke-dashoffset .7s .9s',
        }}
      />
      <path
        d="M0 156 Q 35 150 70 156 T 140 156 T 210 156 T 290 156 V190 H0Z"
        style={{ fill: color.accent, opacity: 0.18 }}
      />
    </svg>
  );
}
